import { gql } from 'graphql-request'

export namespace ScheduledCommunicationTypesQueries {
  export const QUERY_KEYS = {
    getScheduledCommunicationTypes: 'getScheduledCommunicationTypes',
    getScheduledCommunicationType: 'getScheduledCommunicationType',
  }

  export function getScheduledCommunicationTypes() {
    return gql`
      query getScheduledCommunicationTypes() {
        scheduledCommunicationTypes {
          ...ScheduledCommunicationTypeSummary
        }
      }
      ${ScheduledCommunicationTypesQueries.SCHEDULED_COMMUNICATION_TYPE_SUMMARY}
    `
  }

  export function getScheduledCommunicationType() {
    return gql`
      query getScheduledCommunicationType($id: Int!) {
        scheduledCommunicationType(id: $id) {
          id
          active
          baselineMetric
          defaultToApproved
          leadTime
          numberOfScheduleUnits
          scheduleUnits
          timeToSend
        }
      }
    `
  }

  export const SCHEDULED_COMMUNICATION_TYPE_SUMMARY = gql`
    fragment ScheduledCommunicationTypeSummary on ScheduledCommunicationType {
      id
      active
      description
      timeToSend
    }
  `
}
